import { useAssistantStore, type AssistantMessage } from '@/stores/assistantStore';

export interface GuideChatFields {
  guideTextKey?: string;
  guideNoticeKey?: string;
  guideParams?: Record<string, string | number | boolean>;
}

let sequence = 0;

function nextGuideMessageId(): string {
  sequence += 1;
  return `guide-${String(sequence)}`;
}

/** Open Buddy on the chat so a guide line is visible. */
export function openBuddyForGuide(): void {
  const assistant = useAssistantStore.getState();
  if (!assistant.isOpen) assistant.setOpen(true);
  if (assistant.view !== 'chat') assistant.setView('chat');
}

export function postGuideChatLine(fields: GuideChatFields): void {
  openBuddyForGuide();
  const message: AssistantMessage = {
    id: nextGuideMessageId(),
    role: 'assistant',
    content: '',
    createdAt: new Date().toISOString(),
    type: 'guide',
    plain: true,
  };
  if (fields.guideTextKey !== undefined) message.guideTextKey = fields.guideTextKey;
  if (fields.guideNoticeKey !== undefined) message.guideNoticeKey = fields.guideNoticeKey;
  if (fields.guideParams !== undefined) message.guideParams = fields.guideParams;
  useAssistantStore.getState().addMessage(message);
}
